import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {BaseRouteService} from './BaseRouteService';
import type {ViewModeType} from './IRouteService';

export type VendorPersonnelFromTab = 'all' | 'vendor' | 'activity';

export class VendorManagePersonnelRouteService extends BaseRouteService {
  constructor(
    enableGoHome: boolean,
    mode: ViewModeType,
    parameters: {[key: string]: any}
  ) {
    super(enableGoHome, mode, parameters);
  }

  getCreateRoute(): string {
    const vendorId = this.parameters['vendorId'];
    return PathUtility.VendorPersonnelCreate(vendorId);
  }

  getEditRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const vendorId = this.parameters['vendorId'];
    const fromTab: VendorPersonnelFromTab = this.parameters['fromTab'] || 'vendor';
    return `${PathUtility.VendorPersonnelEdit(id, vendorId, view)}?from=${fromTab}`;
  }

  getViewRoute(id: string | number): string {
    const view: PersonnelViewType = this.parameters['view'] || 'overview';
    const vendorId = this.parameters['vendorId'];
    const fromTab: VendorPersonnelFromTab = this.parameters['fromTab'] || 'vendor';
    return `${PathUtility.VendorPersonnelView(id, vendorId, view)}?from=${fromTab}`;
  }

  getGoBackRoute(id?: string | number): string {
    switch (this.mode) {
      case 'create':
      case 'view':
        return this.getGoHomeRoute();

      case 'edit':
        return this.getViewRoute(id!);

      default:
        return '';
    }
  }

  getGoHomeRoute(): string {
    const fromTab: VendorPersonnelFromTab = this.parameters['fromTab'] || 'vendor';
    if (fromTab === 'all' || fromTab === 'activity') {
      return PathUtility.Personnel(fromTab);
    }
    const vendorId = this.parameters['vendorId'];
    return PathUtility.VendorsView(vendorId, 'personnel');
  }
}
